export const USER_SET_PROFILE = "USER_SET_PROFILE";
export const USER_UPDATE_SPOTIFY_TOKEN = "USER_UPDATE_SPOTIFY_TOKEN";